module.exports = __webpack_public_path__ + "static/media/bell-solid.cc50d197.png";